 
import EstimationAndJobForm from '../common/EstimationAndJob/EstimationAndJobForm';
  
const EstimationForm = () => {
  return (
    <EstimationAndJobForm type="estimation" />
  )
}
export default EstimationForm;